export default __webpack_public_path__ + "static/media/accessibleBanking.e0f703c7.jpg";